import { render } from "./ScheduleAppointmentCard.vue?vue&type=template&id=0509ffe4&scoped=true"
import script from "./ScheduleAppointmentCard.vue?vue&type=script&lang=js"
export * from "./ScheduleAppointmentCard.vue?vue&type=script&lang=js"

import "./ScheduleAppointmentCard.vue?vue&type=style&index=0&id=0509ffe4&scoped=true&lang=css"

import exportComponent from "/var/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0509ffe4"]])

export default __exports__